import { Model } from '@vuex-orm/core'

export class UnitsTo extends Model {
  static entity = 'unitsTo'
  static primaryKey = ['substitution_id', 'unit_id']

  static fields () {
    return {
      substitution_id: this.attr(null),
      unit_id: this.attr(null)
    }
  }
}

export default UnitsTo
